import React, { ReactElement } from 'react';
import { ZCDCheckbox, ZCDCheckboxVariant } from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import { ReportFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';

export const ToggleDivisionChildrenOrSiblingsFilter = (props: ReportFilterProps<boolean>): ReactElement | null => {
  const { value, onChange, filterValues } = props;
  const { t: translate } = useTranslation();

  const isFilteredByDivision = !!filterValues?.division;
  const filterValue = !!value;

  return isFilteredByDivision ? (
    <ZCDCheckbox
      variant={ZCDCheckboxVariant.TOGGLE}
      label={translate('widgetGenerator.displaySiblings')}
      onChange={onChange}
      checked={filterValue}
    />
  ) : null;
};
